import React from 'react';
import FormField from './FormField';

/**
 * Checkbox with consistent styling.
 * layout: "toggle-card" (settings rows) | "inline" (compact)
 */
export default function CheckboxField({
    label,
    description,
    name,
    id,
    checked,
    onChange,
    disabled = false,
    layout = 'inline',
    className = '',
    ...props
}) {
    const inputId = id || (name ? `checkbox-${name}` : undefined);

    const input = (
        <input
            type="checkbox"
            id={inputId}
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={layout === 'toggle-card' ? 'h-5 w-5 shrink-0' : 'h-4 w-4 rounded border-slate-300 text-primary-600 focus:ring-primary-500'}
            {...props}
        />
    );

    if (layout === 'toggle-card') {
        return (
            <label
                htmlFor={inputId}
                className={`toggle-card ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${className}`.trim()}
                aria-disabled={disabled || undefined}
            >
                <div>
                    {label ? <span className="text-sm font-semibold text-slate-800">{label}</span> : null}
                    {description ? <p className="field-note !mt-1">{description}</p> : null}
                </div>
                {input}
            </label>
        );
    }

    return (
        <label
            htmlFor={inputId}
            className={`inline-flex items-start gap-2 ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${className}`.trim()}
            aria-disabled={disabled || undefined}
        >
            {input}
            <span>
                {label ? <span className="text-sm font-medium text-slate-700">{label}</span> : null}
                {description ? <span className="block field-note !mt-0.5">{description}</span> : null}
            </span>
        </label>
    );
}
